import { render, staticRenderFns } from "./PopoverEdit.vue?vue&type=template&id=17840e5a&scoped=true"
import script from "./PopoverEdit.vue?vue&type=script&lang=js"
export * from "./PopoverEdit.vue?vue&type=script&lang=js"
import style0 from "./PopoverEdit.vue?vue&type=style&index=0&id=17840e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17840e5a",
  null
  
)

export default component.exports